// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newHeaderAccordion":"_056yi","main":"NFtVx","title":"DlSxr","dropdownMenu":"zl1Ty","dropdownMenuWrapper":"_-0RTr"};